import type { CountryIso3166 } from "@tfg/db"

import { i18n } from "~/i18n"

export const COUNTRIES: {
  [Country in CountryIso3166]: {
    countryName: string
    emoji: string
    code: Country
    priority: number
  }
} = {
  ZW: {
    countryName: i18n.t("countries.ZW"),
    code: "ZW",
    emoji: "🇿🇼",
    priority: 0,
  },
  ZM: {
    countryName: i18n.t("countries.ZM"),
    code: "ZM",
    emoji: "🇿🇲",
    priority: 0,
  },
  ZA: {
    countryName: i18n.t("countries.ZA"),
    code: "ZA",
    emoji: "🇿🇦",
    priority: 0,
  },
  YT: {
    countryName: i18n.t("countries.YT"),
    code: "YT",
    emoji: "🇾🇹",
    priority: 0,
  },
  YE: {
    countryName: i18n.t("countries.YE"),
    code: "YE",
    emoji: "🇾🇪",
    priority: 0,
  },
  XK: {
    countryName: i18n.t("countries.XK"),
    code: "XK",
    emoji: "🇽🇰",
    priority: 0,
  },
  WS: {
    countryName: i18n.t("countries.WS"),
    code: "WS",
    emoji: "🇼🇸",
    priority: 0,
  },
  WF: {
    countryName: i18n.t("countries.WF"),
    code: "WF",
    emoji: "🇼🇫",
    priority: 0,
  },
  VU: {
    countryName: i18n.t("countries.VU"),
    code: "VU",
    emoji: "🇻🇺",
    priority: 0,
  },
  VN: {
    countryName: i18n.t("countries.VN"),
    code: "VN",
    emoji: "🇻🇳",
    priority: 0,
  },
  VI: {
    countryName: i18n.t("countries.VI"),
    code: "VI",
    emoji: "🇻🇮",
    priority: 0,
  },
  VG: {
    countryName: i18n.t("countries.VG"),
    code: "VG",
    emoji: "🇻🇬",
    priority: 0,
  },
  VE: {
    countryName: i18n.t("countries.VE"),
    code: "VE",
    emoji: "🇻🇪",
    priority: 0,
  },
  VC: {
    countryName: i18n.t("countries.VC"),
    code: "VC",
    emoji: "🇻🇨",
    priority: 0,
  },
  VA: {
    countryName: i18n.t("countries.VA"),
    code: "VA",
    emoji: "🇻🇦",
    priority: 0,
  },
  UZ: {
    countryName: i18n.t("countries.UZ"),
    code: "UZ",
    emoji: "🇺🇿",
    priority: 0,
  },
  UY: {
    countryName: i18n.t("countries.UY"),
    code: "UY",
    emoji: "🇺🇾",
    priority: 0,
  },
  US: {
    countryName: i18n.t("countries.US"),
    code: "US",
    emoji: "🇺🇸",
    priority: 0,
  },
  UN: {
    countryName: i18n.t("countries.UN"),
    code: "UN",
    emoji: "🇺🇳",
    priority: 0,
  },
  UM: {
    countryName: i18n.t("countries.UM"),
    code: "UM",
    emoji: "🇺🇲",
    priority: 0,
  },
  UG: {
    countryName: i18n.t("countries.UG"),
    code: "UG",
    emoji: "🇺🇬",
    priority: 0,
  },
  UA: {
    countryName: i18n.t("countries.UA"),
    code: "UA",
    emoji: "🇺🇦",
    priority: 0,
  },
  TZ: {
    countryName: i18n.t("countries.TZ"),
    code: "TZ",
    emoji: "🇹🇿",
    priority: 0,
  },
  TW: {
    countryName: i18n.t("countries.TW"),
    code: "TW",
    emoji: "🇹🇼",
    priority: 0,
  },
  TV: {
    countryName: i18n.t("countries.TV"),
    code: "TV",
    emoji: "🇹🇻",
    priority: 0,
  },
  TT: {
    countryName: i18n.t("countries.TT"),
    code: "TT",
    emoji: "🇹🇹",
    priority: 0,
  },
  TR: {
    countryName: i18n.t("countries.TR"),
    code: "TR",
    emoji: "🇹🇷",
    priority: 93,
  },
  TO: {
    countryName: i18n.t("countries.TO"),
    code: "TO",
    emoji: "🇹🇴",
    priority: 0,
  },
  TN: {
    countryName: i18n.t("countries.TN"),
    code: "TN",
    emoji: "🇹🇳",
    priority: 91,
  },
  TM: {
    countryName: i18n.t("countries.TM"),
    code: "TM",
    emoji: "🇹🇲",
    priority: 0,
  },
  TL: {
    countryName: i18n.t("countries.TL"),
    code: "TL",
    emoji: "🇹🇱",
    priority: 0,
  },
  TK: {
    countryName: i18n.t("countries.TK"),
    code: "TK",
    emoji: "🇹🇰",
    priority: 0,
  },
  TJ: {
    countryName: i18n.t("countries.TJ"),
    code: "TJ",
    emoji: "🇹🇯",
    priority: 0,
  },
  TH: {
    countryName: i18n.t("countries.TH"),
    code: "TH",
    emoji: "🇹🇭",
    priority: 0,
  },
  TG: {
    countryName: i18n.t("countries.TG"),
    code: "TG",
    emoji: "🇹🇬",
    priority: 0,
  },
  TF: {
    countryName: i18n.t("countries.TF"),
    code: "TF",
    emoji: "🇹🇫",
    priority: 0,
  },
  TD: {
    countryName: i18n.t("countries.TD"),
    code: "TD",
    emoji: "🇹🇩",
    priority: 0,
  },
  TC: {
    countryName: i18n.t("countries.TC"),
    code: "TC",
    emoji: "🇹🇨",
    priority: 0,
  },
  TA: {
    countryName: i18n.t("countries.TA"),
    code: "TA",
    emoji: "🇹🇦",
    priority: 0,
  },
  SZ: {
    countryName: i18n.t("countries.SZ"),
    code: "SZ",
    emoji: "🇸🇿",
    priority: 0,
  },
  SY: {
    countryName: i18n.t("countries.SY"),
    code: "SY",
    emoji: "🇸🇾",
    priority: 0,
  },
  SX: {
    countryName: i18n.t("countries.SX"),
    code: "SX",
    emoji: "🇸🇽",
    priority: 0,
  },
  SV: {
    countryName: i18n.t("countries.SV"),
    code: "SV",
    emoji: "🇸🇻",
    priority: 0,
  },
  ST: {
    countryName: i18n.t("countries.ST"),
    code: "ST",
    emoji: "🇸🇹",
    priority: 0,
  },
  SS: {
    countryName: i18n.t("countries.SS"),
    code: "SS",
    emoji: "🇸🇸",
    priority: 0,
  },
  SR: {
    countryName: i18n.t("countries.SR"),
    code: "SR",
    emoji: "🇸🇷",
    priority: 0,
  },
  SO: {
    countryName: i18n.t("countries.SO"),
    code: "SO",
    emoji: "🇸🇴",
    priority: 0,
  },
  SN: {
    countryName: i18n.t("countries.SN"),
    code: "SN",
    emoji: "🇸🇳",
    priority: 0,
  },
  SM: {
    countryName: i18n.t("countries.SM"),
    code: "SM",
    emoji: "🇸🇲",
    priority: 0,
  },
  SL: {
    countryName: i18n.t("countries.SL"),
    code: "SL",
    emoji: "🇸🇱",
    priority: 0,
  },
  SK: {
    countryName: i18n.t("countries.SK"),
    code: "SK",
    emoji: "🇸🇰",
    priority: 0,
  },
  SJ: {
    countryName: i18n.t("countries.SJ"),
    code: "SJ",
    emoji: "🇸🇯",
    priority: 0,
  },
  SI: {
    countryName: i18n.t("countries.SI"),
    code: "SI",
    emoji: "🇸🇮",
    priority: 0,
  },
  SH: {
    countryName: i18n.t("countries.SH"),
    code: "SH",
    emoji: "🇸🇭",
    priority: 0,
  },
  SG: {
    countryName: i18n.t("countries.SG"),
    code: "SG",
    emoji: "🇸🇬",
    priority: 0,
  },
  SE: {
    countryName: i18n.t("countries.SE"),
    code: "SE",
    emoji: "🇸🇪",
    priority: 0,
  },
  SD: {
    countryName: i18n.t("countries.SD"),
    code: "SD",
    emoji: "🇸🇩",
    priority: 0,
  },
  SC: {
    countryName: i18n.t("countries.SC"),
    code: "SC",
    emoji: "🇸🇨",
    priority: 0,
  },
  SB: {
    countryName: i18n.t("countries.SB"),
    code: "SB",
    emoji: "🇸🇧",
    priority: 0,
  },
  SA: {
    countryName: i18n.t("countries.SA"),
    code: "SA",
    emoji: "🇸🇦",
    priority: 0,
  },
  RW: {
    countryName: i18n.t("countries.RW"),
    code: "RW",
    emoji: "🇷🇼",
    priority: 0,
  },
  RU: {
    countryName: i18n.t("countries.RU"),
    code: "RU",
    emoji: "🇷🇺",
    priority: 0,
  },
  RS: {
    countryName: i18n.t("countries.RS"),
    code: "RS",
    emoji: "🇷🇸",
    priority: 0,
  },
  RO: {
    countryName: i18n.t("countries.RO"),
    code: "RO",
    emoji: "🇷🇴",
    priority: 90,
  },
  RE: {
    countryName: i18n.t("countries.RE"),
    code: "RE",
    emoji: "🇷🇪",
    priority: 0,
  },
  QA: {
    countryName: i18n.t("countries.QA"),
    code: "QA",
    emoji: "🇶🇦",
    priority: 0,
  },
  PY: {
    countryName: i18n.t("countries.PY"),
    code: "PY",
    emoji: "🇵🇾",
    priority: 0,
  },
  PW: {
    countryName: i18n.t("countries.PW"),
    code: "PW",
    emoji: "🇵🇼",
    priority: 0,
  },
  PT: {
    countryName: i18n.t("countries.PT"),
    code: "PT",
    emoji: "🇵🇹",
    priority: 95,
  },
  PS: {
    countryName: i18n.t("countries.PS"),
    code: "PS",
    emoji: "🇵🇸",
    priority: 0,
  },
  PR: {
    countryName: i18n.t("countries.PR"),
    code: "PR",
    emoji: "🇵🇷",
    priority: 0,
  },
  PN: {
    countryName: i18n.t("countries.PN"),
    code: "PN",
    emoji: "🇵🇳",
    priority: 0,
  },
  PM: {
    countryName: i18n.t("countries.PM"),
    code: "PM",
    emoji: "🇵🇲",
    priority: 0,
  },
  PL: {
    countryName: i18n.t("countries.PL"),
    code: "PL",
    emoji: "🇵🇱",
    priority: 0,
  },
  PK: {
    countryName: i18n.t("countries.PK"),
    code: "PK",
    emoji: "🇵🇰",
    priority: 89,
  },
  PH: {
    countryName: i18n.t("countries.PH"),
    code: "PH",
    emoji: "🇵🇭",
    priority: 0,
  },
  PG: {
    countryName: i18n.t("countries.PG"),
    code: "PG",
    emoji: "🇵🇬",
    priority: 0,
  },
  PF: {
    countryName: i18n.t("countries.PF"),
    code: "PF",
    emoji: "🇵🇫",
    priority: 0,
  },
  PE: {
    countryName: i18n.t("countries.PE"),
    code: "PE",
    emoji: "🇵🇪",
    priority: 0,
  },
  PA: {
    countryName: i18n.t("countries.PA"),
    code: "PA",
    emoji: "🇵🇦",
    priority: 0,
  },
  OM: {
    countryName: i18n.t("countries.OM"),
    code: "OM",
    emoji: "🇴🇲",
    priority: 0,
  },
  NZ: {
    countryName: i18n.t("countries.NZ"),
    code: "NZ",
    emoji: "🇳🇿",
    priority: 0,
  },
  NU: {
    countryName: i18n.t("countries.NU"),
    code: "NU",
    emoji: "🇳🇺",
    priority: 0,
  },
  NR: {
    countryName: i18n.t("countries.NR"),
    code: "NR",
    emoji: "🇳🇷",
    priority: 0,
  },
  NP: {
    countryName: i18n.t("countries.NP"),
    code: "NP",
    emoji: "🇳🇵",
    priority: 0,
  },
  NO: {
    countryName: i18n.t("countries.NO"),
    code: "NO",
    emoji: "🇳🇴",
    priority: 0,
  },
  NL: {
    countryName: i18n.t("countries.NL"),
    code: "NL",
    emoji: "🇳🇱",
    priority: 0,
  },
  NI: {
    countryName: i18n.t("countries.NI"),
    code: "NI",
    emoji: "🇳🇮",
    priority: 0,
  },
  NG: {
    countryName: i18n.t("countries.NG"),
    code: "NG",
    emoji: "🇳🇬",
    priority: 0,
  },
  NF: {
    countryName: i18n.t("countries.NF"),
    code: "NF",
    emoji: "🇳🇫",
    priority: 0,
  },
  NE: {
    countryName: i18n.t("countries.NE"),
    code: "NE",
    emoji: "🇳🇪",
    priority: 0,
  },
  NC: {
    countryName: i18n.t("countries.NC"),
    code: "NC",
    emoji: "🇳🇨",
    priority: 0,
  },
  NA: {
    countryName: i18n.t("countries.NA"),
    code: "NA",
    emoji: "🇳🇦",
    priority: 0,
  },
  MZ: {
    countryName: i18n.t("countries.MZ"),
    code: "MZ",
    emoji: "🇲🇿",
    priority: 0,
  },
  MY: {
    countryName: i18n.t("countries.MY"),
    code: "MY",
    emoji: "🇲🇾",
    priority: 0,
  },
  MX: {
    countryName: i18n.t("countries.MX"),
    code: "MX",
    emoji: "🇲🇽",
    priority: 0,
  },
  MW: {
    countryName: i18n.t("countries.MW"),
    code: "MW",
    emoji: "🇲🇼",
    priority: 0,
  },
  MV: {
    countryName: i18n.t("countries.MV"),
    code: "MV",
    emoji: "🇲🇻",
    priority: 0,
  },
  MU: {
    countryName: i18n.t("countries.MU"),
    code: "MU",
    emoji: "🇲🇺",
    priority: 0,
  },
  MT: {
    countryName: i18n.t("countries.MT"),
    code: "MT",
    emoji: "🇲🇹",
    priority: 0,
  },
  MS: {
    countryName: i18n.t("countries.MS"),
    code: "MS",
    emoji: "🇲🇸",
    priority: 0,
  },
  MR: {
    countryName: i18n.t("countries.MR"),
    code: "MR",
    emoji: "🇲🇷",
    priority: 0,
  },
  MQ: {
    countryName: i18n.t("countries.MQ"),
    code: "MQ",
    emoji: "🇲🇶",
    priority: 0,
  },
  MP: {
    countryName: i18n.t("countries.MP"),
    code: "MP",
    emoji: "🇲🇵",
    priority: 0,
  },
  MO: {
    countryName: i18n.t("countries.MO"),
    code: "MO",
    emoji: "🇲🇴",
    priority: 0,
  },
  MN: {
    countryName: i18n.t("countries.MN"),
    code: "MN",
    emoji: "🇲🇳",
    priority: 0,
  },
  MM: {
    countryName: i18n.t("countries.MM"),
    code: "MM",
    emoji: "🇲🇲",
    priority: 0,
  },
  ML: {
    countryName: i18n.t("countries.ML"),
    code: "ML",
    emoji: "🇲🇱",
    priority: 0,
  },
  MK: {
    countryName: i18n.t("countries.MK"),
    code: "MK",
    emoji: "🇲🇰",
    priority: 0,
  },
  MH: {
    countryName: i18n.t("countries.MH"),
    code: "MH",
    emoji: "🇲🇭",
    priority: 0,
  },
  MG: {
    countryName: i18n.t("countries.MG"),
    code: "MG",
    emoji: "🇲🇬",
    priority: 0,
  },
  MF: {
    countryName: i18n.t("countries.MF"),
    code: "MF",
    emoji: "🇲🇫",
    priority: 0,
  },
  ME: {
    countryName: i18n.t("countries.ME"),
    code: "ME",
    emoji: "🇲🇪",
    priority: 0,
  },
  MD: {
    countryName: i18n.t("countries.MD"),
    code: "MD",
    emoji: "🇲🇩",
    priority: 0,
  },
  MC: {
    countryName: i18n.t("countries.MC"),
    code: "MC",
    emoji: "🇲🇨",
    priority: 0,
  },
  MA: {
    countryName: i18n.t("countries.MA"),
    code: "MA",
    emoji: "🇲🇦",
    priority: 92,
  },
  LY: {
    countryName: i18n.t("countries.LY"),
    code: "LY",
    emoji: "🇱🇾",
    priority: 0,
  },
  LV: {
    countryName: i18n.t("countries.LV"),
    code: "LV",
    emoji: "🇱🇻",
    priority: 0,
  },
  LU: {
    countryName: i18n.t("countries.LU"),
    code: "LU",
    emoji: "🇱🇺",
    priority: 0,
  },
  LT: {
    countryName: i18n.t("countries.LT"),
    code: "LT",
    emoji: "🇱🇹",
    priority: 0,
  },
  LS: {
    countryName: i18n.t("countries.LS"),
    code: "LS",
    emoji: "🇱🇸",
    priority: 0,
  },
  LR: {
    countryName: i18n.t("countries.LR"),
    code: "LR",
    emoji: "🇱🇷",
    priority: 0,
  },
  LK: {
    countryName: i18n.t("countries.LK"),
    code: "LK",
    emoji: "🇱🇰",
    priority: 0,
  },
  LI: {
    countryName: i18n.t("countries.LI"),
    code: "LI",
    emoji: "🇱🇮",
    priority: 0,
  },
  LC: {
    countryName: i18n.t("countries.LC"),
    code: "LC",
    emoji: "🇱🇨",
    priority: 0,
  },
  LB: {
    countryName: i18n.t("countries.LB"),
    code: "LB",
    emoji: "🇱🇧",
    priority: 0,
  },
  LA: {
    countryName: i18n.t("countries.LA"),
    code: "LA",
    emoji: "🇱🇦",
    priority: 0,
  },
  KZ: {
    countryName: i18n.t("countries.KZ"),
    code: "KZ",
    emoji: "🇰🇿",
    priority: 0,
  },
  KY: {
    countryName: i18n.t("countries.KY"),
    code: "KY",
    emoji: "🇰🇾",
    priority: 0,
  },
  KW: {
    countryName: i18n.t("countries.KW"),
    code: "KW",
    emoji: "🇰🇼",
    priority: 0,
  },
  KR: {
    countryName: i18n.t("countries.KR"),
    code: "KR",
    emoji: "🇰🇷",
    priority: 0,
  },
  KP: {
    countryName: i18n.t("countries.KP"),
    code: "KP",
    emoji: "🇰🇵",
    priority: 0,
  },
  KN: {
    countryName: i18n.t("countries.KN"),
    code: "KN",
    emoji: "🇰🇳",
    priority: 0,
  },
  KM: {
    countryName: i18n.t("countries.KM"),
    code: "KM",
    emoji: "🇰🇲",
    priority: 0,
  },
  KI: {
    countryName: i18n.t("countries.KI"),
    code: "KI",
    emoji: "🇰🇮",
    priority: 0,
  },
  KH: {
    countryName: i18n.t("countries.KH"),
    code: "KH",
    emoji: "🇰🇭",
    priority: 0,
  },
  KG: {
    countryName: i18n.t("countries.KG"),
    code: "KG",
    emoji: "🇰🇬",
    priority: 0,
  },
  KE: {
    countryName: i18n.t("countries.KE"),
    code: "KE",
    emoji: "🇰🇪",
    priority: 0,
  },
  JP: {
    countryName: i18n.t("countries.JP"),
    code: "JP",
    emoji: "🇯🇵",
    priority: 0,
  },
  JO: {
    countryName: i18n.t("countries.JO"),
    code: "JO",
    emoji: "🇯🇴",
    priority: 0,
  },
  JM: {
    countryName: i18n.t("countries.JM"),
    code: "JM",
    emoji: "🇯🇲",
    priority: 0,
  },
  JE: {
    countryName: i18n.t("countries.JE"),
    code: "JE",
    emoji: "🇯🇪",
    priority: 0,
  },
  IT: {
    countryName: i18n.t("countries.IT"),
    code: "IT",
    emoji: "🇮🇹",
    priority: 97,
  },
  IS: {
    countryName: i18n.t("countries.IS"),
    code: "IS",
    emoji: "🇮🇸",
    priority: 0,
  },
  IR: {
    countryName: i18n.t("countries.IR"),
    code: "IR",
    emoji: "🇮🇷",
    priority: 0,
  },
  IQ: {
    countryName: i18n.t("countries.IQ"),
    code: "IQ",
    emoji: "🇮🇶",
    priority: 0,
  },
  IO: {
    countryName: i18n.t("countries.IO"),
    code: "IO",
    emoji: "🇮🇴",
    priority: 0,
  },
  IN: {
    countryName: i18n.t("countries.IN"),
    code: "IN",
    emoji: "🇮🇳",
    priority: 99,
  },
  IM: {
    countryName: i18n.t("countries.IM"),
    code: "IM",
    emoji: "🇮🇲",
    priority: 0,
  },
  IL: {
    countryName: i18n.t("countries.IL"),
    code: "IL",
    emoji: "🇮🇱",
    priority: 0,
  },
  IE: {
    countryName: i18n.t("countries.IE"),
    code: "IE",
    emoji: "🇮🇪",
    priority: 0,
  },
  ID: {
    countryName: i18n.t("countries.ID"),
    code: "ID",
    emoji: "🇮🇩",
    priority: 0,
  },
  IC: {
    countryName: i18n.t("countries.IC"),
    code: "IC",
    emoji: "🇮🇨",
    priority: 0,
  },
  HU: {
    countryName: i18n.t("countries.HU"),
    code: "HU",
    emoji: "🇭🇺",
    priority: 0,
  },
  HT: {
    countryName: i18n.t("countries.HT"),
    code: "HT",
    emoji: "🇭🇹",
    priority: 0,
  },
  HR: {
    countryName: i18n.t("countries.HR"),
    code: "HR",
    emoji: "🇭🇷",
    priority: 0,
  },
  HN: {
    countryName: i18n.t("countries.HN"),
    code: "HN",
    emoji: "🇭🇳",
    priority: 0,
  },
  HM: {
    countryName: i18n.t("countries.HM"),
    code: "HM",
    emoji: "🇭🇲",
    priority: 0,
  },
  HK: {
    countryName: i18n.t("countries.HK"),
    code: "HK",
    emoji: "🇭🇰",
    priority: 0,
  },
  GY: {
    countryName: i18n.t("countries.GY"),
    code: "GY",
    emoji: "🇬🇾",
    priority: 0,
  },
  GW: {
    countryName: i18n.t("countries.GW"),
    code: "GW",
    emoji: "🇬🇼",
    priority: 0,
  },
  GU: {
    countryName: i18n.t("countries.GU"),
    code: "GU",
    emoji: "🇬🇺",
    priority: 0,
  },
  GT: {
    countryName: i18n.t("countries.GT"),
    code: "GT",
    emoji: "🇬🇹",
    priority: 0,
  },
  GS: {
    countryName: i18n.t("countries.GS"),
    code: "GS",
    emoji: "🇬🇸",
    priority: 0,
  },
  GR: {
    countryName: i18n.t("countries.GR"),
    code: "GR",
    emoji: "🇬🇷",
    priority: 0,
  },
  GQ: {
    countryName: i18n.t("countries.GQ"),
    code: "GQ",
    emoji: "🇬🇶",
    priority: 0,
  },
  GP: {
    countryName: i18n.t("countries.GP"),
    code: "GP",
    emoji: "🇬🇵",
    priority: 0,
  },
  GN: {
    countryName: i18n.t("countries.GN"),
    code: "GN",
    emoji: "🇬🇳",
    priority: 0,
  },
  GM: {
    countryName: i18n.t("countries.GM"),
    code: "GM",
    emoji: "🇬🇲",
    priority: 0,
  },
  GL: {
    countryName: i18n.t("countries.GL"),
    code: "GL",
    emoji: "🇬🇱",
    priority: 0,
  },
  GI: {
    countryName: i18n.t("countries.GI"),
    code: "GI",
    emoji: "🇬🇮",
    priority: 0,
  },
  GH: {
    countryName: i18n.t("countries.GH"),
    code: "GH",
    emoji: "🇬🇭",
    priority: 0,
  },
  GG: {
    countryName: i18n.t("countries.GG"),
    code: "GG",
    emoji: "🇬🇬",
    priority: 0,
  },
  GF: {
    countryName: i18n.t("countries.GF"),
    code: "GF",
    emoji: "🇬🇫",
    priority: 0,
  },
  GE: {
    countryName: i18n.t("countries.GE"),
    code: "GE",
    emoji: "🇬🇪",
    priority: 0,
  },
  GD: {
    countryName: i18n.t("countries.GD"),
    code: "GD",
    emoji: "🇬🇩",
    priority: 0,
  },
  GB: {
    countryName: i18n.t("countries.GB"),
    code: "GB",
    emoji: "🇬🇧",
    priority: 0,
  },
  GA: {
    countryName: i18n.t("countries.GA"),
    code: "GA",
    emoji: "🇬🇦",
    priority: 0,
  },
  FR: {
    countryName: i18n.t("countries.FR"),
    code: "FR",
    emoji: "🇫🇷",
    priority: 100,
  },
  FO: {
    countryName: i18n.t("countries.FO"),
    code: "FO",
    emoji: "🇫🇴",
    priority: 0,
  },
  FM: {
    countryName: i18n.t("countries.FM"),
    code: "FM",
    emoji: "🇫🇲",
    priority: 0,
  },
  FK: {
    countryName: i18n.t("countries.FK"),
    code: "FK",
    emoji: "🇫🇰",
    priority: 0,
  },
  FJ: {
    countryName: i18n.t("countries.FJ"),
    code: "FJ",
    emoji: "🇫🇯",
    priority: 0,
  },
  FI: {
    countryName: i18n.t("countries.FI"),
    code: "FI",
    emoji: "🇫🇮",
    priority: 0,
  },
  EU: {
    countryName: i18n.t("countries.EU"),
    code: "EU",
    emoji: "🇪🇺",
    priority: 0,
  },
  ET: {
    countryName: i18n.t("countries.ET"),
    code: "ET",
    emoji: "🇪🇹",
    priority: 0,
  },
  ES: {
    countryName: i18n.t("countries.ES"),
    code: "ES",
    emoji: "🇪🇸",
    priority: 96,
  },
  ER: {
    countryName: i18n.t("countries.ER"),
    code: "ER",
    emoji: "🇪🇷",
    priority: 0,
  },
  EH: {
    countryName: i18n.t("countries.EH"),
    code: "EH",
    emoji: "🇪🇭",
    priority: 0,
  },
  EG: {
    countryName: i18n.t("countries.EG"),
    code: "EG",
    emoji: "🇪🇬",
    priority: 0,
  },
  EE: {
    countryName: i18n.t("countries.EE"),
    code: "EE",
    emoji: "🇪🇪",
    priority: 0,
  },
  EC: {
    countryName: i18n.t("countries.EC"),
    code: "EC",
    emoji: "🇪🇨",
    priority: 0,
  },
  EA: {
    countryName: i18n.t("countries.EA"),
    code: "EA",
    emoji: "🇪🇦",
    priority: 0,
  },
  DZ: {
    countryName: i18n.t("countries.DZ"),
    code: "DZ",
    emoji: "🇩🇿",
    priority: 0,
  },
  DO: {
    countryName: i18n.t("countries.DO"),
    code: "DO",
    emoji: "🇩🇴",
    priority: 0,
  },
  DM: {
    countryName: i18n.t("countries.DM"),
    code: "DM",
    emoji: "🇩🇲",
    priority: 0,
  },
  DK: {
    countryName: i18n.t("countries.DK"),
    code: "DK",
    emoji: "🇩🇰",
    priority: 0,
  },
  DJ: {
    countryName: i18n.t("countries.DJ"),
    code: "DJ",
    emoji: "🇩🇯",
    priority: 0,
  },
  DG: {
    countryName: i18n.t("countries.DG"),
    code: "DG",
    emoji: "🇩🇬",
    priority: 0,
  },
  DE: {
    countryName: i18n.t("countries.DE"),
    code: "DE",
    emoji: "🇩🇪",
    priority: 0,
  },
  CZ: {
    countryName: i18n.t("countries.CZ"),
    code: "CZ",
    emoji: "🇨🇿",
    priority: 0,
  },
  CY: {
    countryName: i18n.t("countries.CY"),
    code: "CY",
    emoji: "🇨🇾",
    priority: 0,
  },
  CX: {
    countryName: i18n.t("countries.CX"),
    code: "CX",
    emoji: "🇨🇽",
    priority: 0,
  },
  CW: {
    countryName: i18n.t("countries.CW"),
    code: "CW",
    emoji: "🇨🇼",
    priority: 0,
  },
  CV: {
    countryName: i18n.t("countries.CV"),
    code: "CV",
    emoji: "🇨🇻",
    priority: 0,
  },
  CU: {
    countryName: i18n.t("countries.CU"),
    code: "CU",
    emoji: "🇨🇺",
    priority: 0,
  },
  CR: {
    countryName: i18n.t("countries.CR"),
    code: "CR",
    emoji: "🇨🇷",
    priority: 0,
  },
  CP: {
    countryName: i18n.t("countries.CP"),
    code: "CP",
    emoji: "🇨🇵",
    priority: 0,
  },
  CO: {
    countryName: i18n.t("countries.CO"),
    code: "CO",
    emoji: "🇨🇴",
    priority: 0,
  },
  CN: {
    countryName: i18n.t("countries.CN"),
    code: "CN",
    emoji: "🇨🇳",
    priority: 98,
  },
  CM: {
    countryName: i18n.t("countries.CM"),
    code: "CM",
    emoji: "🇨🇲",
    priority: 0,
  },
  CL: {
    countryName: i18n.t("countries.CL"),
    code: "CL",
    emoji: "🇨🇱",
    priority: 0,
  },
  CK: {
    countryName: i18n.t("countries.CK"),
    code: "CK",
    emoji: "🇨🇰",
    priority: 0,
  },
  CI: {
    countryName: i18n.t("countries.CI"),
    code: "CI",
    emoji: "🇨🇮",
    priority: 0,
  },
  CH: {
    countryName: i18n.t("countries.CH"),
    code: "CH",
    emoji: "🇨🇭",
    priority: 0,
  },
  CG: {
    countryName: i18n.t("countries.CG"),
    code: "CG",
    emoji: "🇨🇬",
    priority: 0,
  },
  CF: {
    countryName: i18n.t("countries.CF"),
    code: "CF",
    emoji: "🇨🇫",
    priority: 0,
  },
  CD: {
    countryName: i18n.t("countries.CD"),
    code: "CD",
    emoji: "🇨🇩",
    priority: 0,
  },
  CC: {
    countryName: i18n.t("countries.CC"),
    code: "CC",
    emoji: "🇨🇨",
    priority: 0,
  },
  CA: {
    countryName: i18n.t("countries.CA"),
    code: "CA",
    emoji: "🇨🇦",
    priority: 0,
  },
  BZ: {
    countryName: i18n.t("countries.BZ"),
    code: "BZ",
    emoji: "🇧🇿",
    priority: 0,
  },
  BY: {
    countryName: i18n.t("countries.BY"),
    code: "BY",
    emoji: "🇧🇾",
    priority: 0,
  },
  BW: {
    countryName: i18n.t("countries.BW"),
    code: "BW",
    emoji: "🇧🇼",
    priority: 0,
  },
  BV: {
    countryName: i18n.t("countries.BV"),
    code: "BV",
    emoji: "🇧🇻",
    priority: 0,
  },
  BT: {
    countryName: i18n.t("countries.BT"),
    code: "BT",
    emoji: "🇧🇹",
    priority: 0,
  },
  BS: {
    countryName: i18n.t("countries.BS"),
    code: "BS",
    emoji: "🇧🇸",
    priority: 0,
  },
  BR: {
    countryName: i18n.t("countries.BR"),
    code: "BR",
    emoji: "🇧🇷",
    priority: 0,
  },
  BQ: {
    countryName: i18n.t("countries.BQ"),
    code: "BQ",
    emoji: "🇧🇶",
    priority: 0,
  },
  BO: {
    countryName: i18n.t("countries.BO"),
    code: "BO",
    emoji: "🇧🇴",
    priority: 0,
  },
  BN: {
    countryName: i18n.t("countries.BN"),
    code: "BN",
    emoji: "🇧🇳",
    priority: 0,
  },
  BM: {
    countryName: i18n.t("countries.BM"),
    code: "BM",
    emoji: "🇧🇲",
    priority: 0,
  },
  BL: {
    countryName: i18n.t("countries.BL"),
    code: "BL",
    emoji: "🇧🇱",
    priority: 0,
  },
  BJ: {
    countryName: i18n.t("countries.BJ"),
    code: "BJ",
    emoji: "🇧🇯",
    priority: 0,
  },
  BI: {
    countryName: i18n.t("countries.BI"),
    code: "BI",
    emoji: "🇧🇮",
    priority: 0,
  },
  BH: {
    countryName: i18n.t("countries.BH"),
    code: "BH",
    emoji: "🇧🇭",
    priority: 0,
  },
  BG: {
    countryName: i18n.t("countries.BG"),
    code: "BG",
    emoji: "🇧🇬",
    priority: 0,
  },
  BF: {
    countryName: i18n.t("countries.BF"),
    code: "BF",
    emoji: "🇧🇫",
    priority: 0,
  },
  BE: {
    countryName: i18n.t("countries.BE"),
    code: "BE",
    emoji: "🇧🇪",
    priority: 0,
  },
  BD: {
    countryName: i18n.t("countries.BD"),
    code: "BD",
    emoji: "🇧🇩",
    priority: 94,
  },
  BB: {
    countryName: i18n.t("countries.BB"),
    code: "BB",
    emoji: "🇧🇧",
    priority: 0,
  },
  BA: {
    countryName: i18n.t("countries.BA"),
    code: "BA",
    emoji: "🇧🇦",
    priority: 0,
  },
  AZ: {
    countryName: i18n.t("countries.AZ"),
    code: "AZ",
    emoji: "🇦🇿",
    priority: 0,
  },
  AX: {
    countryName: i18n.t("countries.AX"),
    code: "AX",
    emoji: "🇦🇽",
    priority: 0,
  },
  AW: {
    countryName: i18n.t("countries.AW"),
    code: "AW",
    emoji: "🇦🇼",
    priority: 0,
  },
  AU: {
    countryName: i18n.t("countries.AU"),
    code: "AU",
    emoji: "🇦🇺",
    priority: 0,
  },
  AT: {
    countryName: i18n.t("countries.AT"),
    code: "AT",
    emoji: "🇦🇹",
    priority: 0,
  },
  AS: {
    countryName: i18n.t("countries.AS"),
    code: "AS",
    emoji: "🇦🇸",
    priority: 0,
  },
  AR: {
    countryName: i18n.t("countries.AR"),
    code: "AR",
    emoji: "🇦🇷",
    priority: 0,
  },
  AQ: {
    countryName: i18n.t("countries.AQ"),
    code: "AQ",
    emoji: "🇦🇶",
    priority: 0,
  },
  AO: {
    countryName: i18n.t("countries.AO"),
    code: "AO",
    emoji: "🇦🇴",
    priority: 0,
  },
  AM: {
    countryName: i18n.t("countries.AM"),
    code: "AM",
    emoji: "🇦🇲",
    priority: 0,
  },
  AL: {
    countryName: i18n.t("countries.AL"),
    code: "AL",
    emoji: "🇦🇱",
    priority: 0,
  },
  AI: {
    countryName: i18n.t("countries.AI"),
    code: "AI",
    emoji: "🇦🇮",
    priority: 0,
  },
  AG: {
    countryName: i18n.t("countries.AG"),
    code: "AG",
    emoji: "🇦🇬",
    priority: 0,
  },
  AF: {
    countryName: i18n.t("countries.AF"),
    code: "AF",
    emoji: "🇦🇫",
    priority: 0,
  },
  AE: {
    countryName: i18n.t("countries.AE"),
    code: "AE",
    emoji: "🇦🇪",
    priority: 0,
  },
  AD: {
    countryName: i18n.t("countries.AD"),
    code: "AD",
    emoji: "🇦🇩",
    priority: 0,
  },
  AC: {
    countryName: i18n.t("countries.AC"),
    code: "AC",
    emoji: "🇦🇨",
    priority: 0,
  },
} as const
